import axios from 'axios'
import {Notification,  MessageBox, Message ,Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { saveAs } from 'file-saver'
import errorCode from '@/utils/errorCode'
import cache from '@/plugins/cache'
import { tansParams ,blobValidate} from "@/utils/tools";

let downloadLoadingInstance;
let messageInstance = null;

// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000 // request timeout
})
// request interceptor
service.interceptors.request.use(config => {
    // do something before request is sent
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    const isRepeatSubmit = true;
    if (getToken() && !isToken) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
      const requestObj = {
        url: config.url,
        data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      } else {
        const s_url = sessionObj.url;                  // 请求地址
        const s_data = sessionObj.data;                // 请求数据
        const s_time = sessionObj.time;                // 请求时间
        const interval = 2000;
        if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
          const message = '数据正在处理，请勿重复提交';
          console.warn(`[${s_url}]: ` + message)
          //弹出提示
          return Promise.reject(new Error(message))
        } else {
          cache.session.setJSON('sessionObj', requestObj)
        }
      }
    }
    return config
  },error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.message || errorCode['default']
  // 二进制数据则直接返回
  if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
    return res.data
  }
  if (code === 401) {
    if (!isRelogin.show) {
      isRelogin.show = true;
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        isRelogin.show = false;
        store.dispatch('LogOut').then(() => {
          //修改默认首页
          // let indexUrl = this.$store.getters.indexPage;
          // location.href = '/dashboard';
          location.href = '/';
        })
      }).catch(() => {
        isRelogin.show = false;
      });
    }
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500) {
    
    showMessage({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject('error')
  } else {
    // return res.data
    return res
  }
},
error => {
  let { message } = error;
  if (message == "Network Error") {
    message = "网络连接异常 ，请稍后重试";
  }
  else if (message.includes("timeout")) {
    message = "服务或网络繁忙，请稍后刷新重试";
  }
  else if (message.includes("Request failed with status code")) {
    message = "服务升级处理中，请稍后重试！";
  }
  else if(message.includes("空指针")){
    message = "服务或网络繁忙，请稍后刷新重试";
  }
  showMessage({
    message: message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})
/*
 *get方法，对应get请求
 *@param {String} url [请求的url地址]
 *@param {Object} params [请求时候携带的参数]
 */
 export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
          .get(url, {
              params
          })
          .then(res => {
              resolve(res);
          })
          .catch(err => {
              reject(err);
          });
  });
}
/*
*post方法，对应post请求
*@param {String} url [请求的url地址]
*@param {Object} params [请求时候携带的参数]
*/
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
          .post(url, params)
          .then(res => {
              resolve(res);
          })
          .catch(err => {
              reject(err);
          });
  });
}
// 通用下载方法
export function download(url, params, filename) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: 
    { 
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': getToken()
    },
    responseType: 'blob'
  }).then(async (data) => {
    const isLogin = await blobValidate(data);
    if (isLogin) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

function showMessage(message) {
  // 如果当前没有 Message 显示，则创建一个新的 Message
  if (!messageInstance) {
    messageInstance = Message(message);
    // 在 Message 关闭后，将 messageInstance 设置为 null
    messageInstance.onClose = function() {
      messageInstance = null;
    };
  }
}

export default service
